import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(_component_b_button, {
    class: "copy-btn",
    type: _ctx.type,
    size: _ctx.size,
    "icon-left": _ctx.currentIcon,
    title: _ctx.success ? _ctx.copiedTitle : _ctx.title,
    "aria-label": _ctx.ariaLabel || _ctx.title,
    onClick: _withModifiers(_ctx.handleClick, ["stop"])
  }, null, 8, ["type", "size", "icon-left", "title", "aria-label", "onClick"]))
}